import React from 'react'

const projects = [
  {
    title: '1PDRMnet.',
    location: 'Central Region, East Coast Region, Southern Region. Malaysia.'
  },
  {
    title: 'Bus Rapid Transit, Bandar Sunway Line',
    location: 'Petaling Jaya, Selangor.'
  },
  {
    title: 'DBKL Surveillance System.',
    location: 'Kuala Lumpur.'
  },
  {
    title: 'MBPJ, MBSA, MPKJ, MPSP, and MPS Surveillance Systems.',
    location: 'Selangor.'
  },
  { title: 'Lembaga Kemajuan Ikan Malaysia.', location: 'Puchong, Selangor.' },
  { title: 'Mahkamah Duta.', location: 'Kuala Lumpur.' },
  {
    title: 'Polis Diraja Malaysia.',
    location: 'Central Region, East Coast Region, Southern Region, Malaysia.'
  },
  { title: 'Prasarana Headquarters.', location: 'Petaling Jaya, Selangor.' }
]

const SectorGoverment = () => {
  return (
    <div className="modal-project-sector">
      <div className="feature-card-modal-content">
        <h2 className="typo-modal-tile-headline modal-headline headline">Government Sector</h2>
        <h4 className="typo-modal-project-sector-subhead">Building</h4>
        <div className="modal-content-article">
          {projects.map((project, index) => (
            <div className="article-content" key={index}>
              <h5 className="typo-feature-card-modal-copy feature-card-modal-copy-highlight">
                {project.title}
              </h5>
              <p className="feature-card-modal-copy typo-feature-card-modal-copy">
                {project.location}
              </p>
            </div>
          ))}
        </div>
        <h6 className="typo-modal-noted">*More projects are being update soon.</h6>
      </div>
    </div>
  )
}

export default SectorGoverment
